import {
  LOADING_TREE,
  LOADING_FILE,
  LOADING_FILE_COUNT,
  LOADING_FILE_UPLOAD_COUNT,
  GET_FILE_UPLOAD_COUNT,
  GET_TREE,
  SUBORDINATE,
  GET_FILE,
  GET_FILES,
  GENERATE_CSV,
  GET_FILE_COUNT,
  MULTIPLE_SELECTED_FILE,
  REFRESH_TREE,
  ACTIVE_TAB,
  UPDATE_FILE,
  BULK_REVIEW_ADD_FILE,
  BULK_REVIEW_ADD_FILE_COUNT,
  ERROR_FILE,
  SAMPLE_PDF_FILE,
  LOADING_RETRY_FILE_UPLOAD,
  RETRY_FILE_UPLOAD,
  ERROR_RETRY_FILE_UPLOAD,
  LOADING_RETRY_FILE_UPLOAD_JOB,
  RETRY_FILE_UPLOAD_JOB,
  ERROR_RETRY_FILE_UPLOAD_JOB,
  LOADING_DELETED_FILES,
  GET_DELETED_FILES,
  ERROR_DELETED_FILES,
  LOADING_IMPORTED_FILES,
  GET_IMPORTED_FILES,
  ERROR_IMPORTED_FILES
} from "store/actions/fileAction";

export default (state = {}, action) => {
  switch (action.type) {
    case LOADING_TREE:
      return {
        ...state,
        isLoadingTree: action.payload
      };
    case LOADING_FILE:
      return {
        ...state,
        isLoadingFile: action.payload
      };
    case LOADING_FILE_COUNT:
      return {
        ...state,
        isLoadingFileCount: action.payload
      };
    case LOADING_FILE_UPLOAD_COUNT:
      return {
        ...state,
        isLoadingFileUploadCount: action.payload
      };
    case ERROR_FILE:
      return {
        ...state,
        errorFile: action.payload
      };
    case GET_TREE:
      return {
        ...state,
        getTreeNodes: action.payload
      };
    case SUBORDINATE:
      return {
        ...state,
        getSubordinate: action.payload
      };
    case GET_FILE:
      return {
        ...state,
        getFile: action.payload
      };
    case GET_FILES:
      return {
        ...state,
        getFiles: action.payload
      };
    case GET_DELETED_FILES:
      return {
        ...state,
        getDeletedFiles: action.payload
      };
    case LOADING_DELETED_FILES:
      return {
        ...state,
        isLoadingDeletedFile: action.payload
      };
    case ERROR_DELETED_FILES:
      return {
        ...state,
        errorDeletedFile: action.payload
      };
    case GET_IMPORTED_FILES:
      return {
        ...state,
        getImportedFiles: action.payload
      };
    case LOADING_IMPORTED_FILES:
      return {
        ...state,
        isLoadingImportedFile: action.payload
      };
    case ERROR_IMPORTED_FILES:
      return {
        ...state,
        errorImportedFile: action.payload
      };
    case GENERATE_CSV:
      return {
        ...state,
        generateCSV: action.payload
      };
    case GET_FILE_COUNT:
      return {
        ...state,
        getFileCount: action.payload
      };
    case GET_FILE_UPLOAD_COUNT:
      return {
        ...state,
        getFileUploadCount: action.payload
      };
    case MULTIPLE_SELECTED_FILE:
      return {
        ...state,
        multipleSelectedFiles: action.payload
      };
    case REFRESH_TREE:
      return {
        ...state,
        doRefresh: action.payload
      };
    case ACTIVE_TAB:
      return {
        ...state,
        getActiveTab: action.payload
      };
    case UPDATE_FILE:
      return {
        ...state,
        httpStatus: action.httpStatus,
        updateFile: action.payload
      };

    // Retry failed upload
    case LOADING_RETRY_FILE_UPLOAD:
      return {
        ...state,
        isLoadingRetryFile: action.payload
      };
    case RETRY_FILE_UPLOAD:
      return {
        ...state,
        retryFileUpload: action.payload
      };
    case ERROR_RETRY_FILE_UPLOAD:
      return {
        ...state,
        errorRetryFileUpload: action.payload
      };
    // Retry failed uploads
    case LOADING_RETRY_FILE_UPLOAD_JOB:
      return {
        ...state,
        isLoadingRetryFiles: action.payload
      };
    case RETRY_FILE_UPLOAD_JOB:
      return {
        ...state,
        retryFileUploads: action.payload
      };
    case ERROR_RETRY_FILE_UPLOAD_JOB:
      return {
        ...state,
        errorRetryFileUploads: action.payload
      };

    case BULK_REVIEW_ADD_FILE:
      return {
        ...state,
        getBulkReviewFiles: action.payload
      };
    case BULK_REVIEW_ADD_FILE_COUNT:
      return {
        ...state,
        getBulkReviewFilesCount: action.payload
      };
    case SAMPLE_PDF_FILE:
      return {
        ...state,
        pdfSampleFileName: action.payload
      };

    default:
      return state;
  }
};
